import { excludedConsoleMethods, getInitialUANCState, IUANCState } from './config';
import { STATE_SERVICE } from '../../configs/constants';

export default class ProxyUANC {
    unresolvedServices: string[];
    level: number | undefined;
    private observers: { [key: string]: (<T>(param: T) => unknown)[] };
    private notify: (prop: [string, boolean | STATE_SERVICE]) => void;
    setState: (newState: Partial<IUANCState>) => void;
    shouldUpdate: <T extends keyof IUANCState>(prop: T, fn: <K>(param: K) => unknown) => void;
    init: ProxyUANC;

    constructor() {
        window.Inpl.Ad.state = Object.assign(getInitialUANCState(), window.Inpl.Ad.state ?? {});
        this.unresolvedServices = ['init'];
        this.observers = {};

        this.notify = (prop) => {
            const [key, value] = prop;
            if (this.observers[key]) {
                this.observers[key].forEach((fn) => fn(value));
            }
        };

        this.setState = (newState) => {
            window.Inpl.Ad.state = Object.assign(window.Inpl.Ad.state ? window.Inpl.Ad.state : getInitialUANCState(), newState);
            Object.entries(newState).forEach((prop) => this.notify(prop));
        };

        this.shouldUpdate = (prop, fn) => {
            if (typeof this.observers[prop] === 'undefined') {
                this.observers[prop] = [];
                this.observers[prop].push(fn);
            } else {
                this.observers[prop].push(fn);
            }
        };

        const proxyHandler: ProxyHandler<ProxyUANC> = {
            set: (target: ProxyUANC, prop: 'unresolvedServices' | 'level', value: any) => {
                target[prop] = value;
                return true;
            },
            get: function (target: ProxyUANC, prop: string, receiver) {
                if (excludedConsoleMethods.indexOf(prop) > -1) return () => true;
                return Reflect.get(target, prop, receiver);
            },
        };

        this.init = new Proxy(this, proxyHandler);
    }
}
